
import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';

import WebDetail from '../../components/ServicesDetails/WebDetail';
import MobileDetail from '../../components/ServicesDetails/MobileDetail';
import CloudDetail from '../../components/ServicesDetails/CloudDetail';
import IntegrationDetail from '../../components/ServicesDetails/IntegrationDetail';
import EcommerceDetail from '../../components/ServicesDetails/EcommerceDetail';
import ErpDetail from '../../components/ServicesDetails/ErpDetail';

const detailComponentBySlug = {
  'developpement-web': WebDetail,
  'applications-mobiles': MobileDetail,
  'solutions-cloud': CloudDetail,
  'integration-de-systemes': IntegrationDetail,
  'applications-e-commerce': EcommerceDetail,
  'erp': ErpDetail,
};

// Fonction utilitaire pour déséchapper le HTML si besoin
function decodeHtml(html) {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
}


export default function ServiceDetail() {
  const { slug } = useParams();
  const DetailComponent = detailComponentBySlug[slug];
  if (!DetailComponent) {
    return <div style={{padding: '3rem', textAlign: 'center'}}><h2>Service introuvable</h2><p>Le service demandé n'existe pas.</p></div>;
  }
  return <DetailComponent />;
}
